import ApiConstants from "../../Constants/ApiConstant";
import { apiDelete, apiGet, apiPost, apiPut } from "../../Services/ApiService";

export const getTransportDetailsAPI = (params, callback) => {
  return async () => {
    try {
      let url = ApiConstants.getTransportUrl;
      const queryParams = [];

      if (params?.searchQuery)
        queryParams.push(`search=${encodeURIComponent(params.searchQuery)}`);
      if (params.page)
        queryParams.push(`page=${encodeURIComponent(params.page)}`);
      if (params.limit)
        queryParams.push(`limit=${encodeURIComponent(params.limit)}`);

      // Append query parameters to URL if they exist
      if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
      }
      await apiGet(url)
        .then((response) => {
          callback && callback(response, response);
        })
        .catch((err) => {
          console.log("get transport details api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("get transport details api err:", err);
      throw err;
    }
  };
};

export const addTransportAPI = (data, callback) => {
  return async () => {
    try {
      await apiPost(ApiConstants.createTransportUrl, data)
        .then((response) => {
          callback && callback(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("add transport api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("add transport api err:", err);
      throw err;
    }
  };
};

export const deleteTransportAPI = (transportId, callback) => {
  return async () => {
    try {
      const url = `${ApiConstants.deleteTransportUrl}?transport_id=${transportId}`;
      await apiDelete(url)
        .then((response) => {
          callback && callback(response?.data);
        })
        .catch((err) => {
          console.log("delete transport api err:", err);
          throw err;
        });
    } catch (err) {
      console.log("delete transport api err:", err);
      throw err;
    }
  };
};

export const updateTransportAPI = (data, callback) => {
  return async () => {
    try {
      await apiPut(ApiConstants.updateTransportUrl, data)
        .then((response) => {
          callback && callback(response?.data, response?.data);
        })
        .catch((err) => {
          console.log("update transport api err===-=>>>:", err);
          throw err;
        });
    } catch (err) {
      console.log("update transport api err:", err);
      throw err;
    }
  };
};
